<div class="connect-with-stripe" [ngStyle]="{'min-height': minHeight}">

  <div class="connect-message field-hint">{{message}}</div>


  <div class="connect-message field-hint second-message">
    <br class="breakIf">
    Check if your country is supported <a target="_blank" href="https://stripe.com/global">here</a>, "preview" means that it's already fully operational.</div>

  <a (click)="connectWithStripe()" class="connect-button"><span>Connect with Stripe</span></a>

  <p class="supported-countries"><a target="_blank" href="https://stripe.com/global">Supported Countries</a></p>



</div>
